export default defineNuxtPlugin(async () => {
    const [
        { gsap },
        { default: Draggable },
        { default: ScrollToPlugin },
        { default: ScrollTrigger },
        { default: ScrambleTextPlugin },
        { default: InertiaPlugin },
        { default: SplitText },
        { default: Observer }
    ] = await Promise.all([
        import("gsap"),
        // @ts-ignore GSAP ships lowercase type files for these uppercase ESM plugin paths on Windows.
        import("gsap/Draggable"),
        import("gsap/ScrollToPlugin"),
        import("gsap/ScrollTrigger"),
        import("gsap/ScrambleTextPlugin"),
        import("gsap/InertiaPlugin"),
        import("gsap/SplitText"),
        // @ts-ignore GSAP ships lowercase type files for these uppercase ESM plugin paths on Windows.
        import("gsap/Observer")
    ]);

    gsap.registerPlugin(
        ScrollTrigger,
        ScrollToPlugin,
        Draggable,
        ScrambleTextPlugin,
        InertiaPlugin,
        SplitText,
        Observer
    );

    gsap.config({
        force3D: true,
        nullTargetWarn: false,
        trialWarn: false
    })

    ScrollTrigger.config({
        ignoreMobileResize: false,
        limitCallbacks: false
    });

    return {
        provide: {
            gsap,
            ScrollTrigger,
            ScrollToPlugin,
            SplitText,
            Draggable,
            ScrambleTextPlugin,
            InertiaPlugin,
            Observer
        },
    }
})
